import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';

import { ModalComponent } from '@shared/modal/modal.component';

import { CmsBlockComponent } from '../../../../common/public-api';

@Component({
    selector: 'checkout-esim-compatibility',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, CmsBlockComponent],
    templateUrl: './esim-compatibility-modal.component.html',
    styleUrls: [],
})
export class EsimCompatibilityComponent extends ModalComponent {
    @ViewChild('customModalFooter') customModalFooter: TemplateRef<any>;

    public title: string = 'Liste des téléphones compatibles eSIM';
}
